import { render, staticRenderFns } from "./TabFilter.vue?vue&type=template&id=3afab0ac"
import script from "./TabFilter.vue?vue&type=script&lang=js"
export * from "./TabFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports